export function updateCookieCampaign (idCampagne, nbJoursCookie = 20) {
   const cookieName = 'o-HPevent'
   let cookieValue = {
      [idCampagne]: 1
   }
   let eventCookie = document.cookie.split('; ').find((cookie) => cookie.includes(cookieName))
   if (eventCookie) {
      try {
         let eventCookieValue = JSON.parse(eventCookie.split('=')[1])
         const currentDisplayValue = parseInt(eventCookieValue[idCampagne], 10) || 0;
         cookieValue[idCampagne] = currentDisplayValue + 1
      } catch (e) {}
   }
   document.cookie = `${cookieName}=${JSON.stringify(cookieValue)}; max-age=${60 * 60 * 24 * nbJoursCookie}; path=/`
}
